'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".ExpandableImage-module_container__i6D1-{position:relative;transition:all .1s ease-in-out}.ExpandableImage-module_button__6RW-a{background:rgba(0,0,0,.5);border:0;border-radius:0 0 0 .25rem;color:#fff;cursor:pointer;padding:.5rem;position:absolute;right:0;top:0;fill:#fff}.ExpandableImage-module_img__TfGqg{width:100%}";
var styles = {"container":"ExpandableImage-module_container__i6D1-","button":"ExpandableImage-module_button__6RW-a","img":"ExpandableImage-module_img__TfGqg"};
styleInject["default"](css_248z, '077e4b75-7353-40ec-8c0e-4f779be07430');

exports["default"] = styles;
